import { createSlice } from "@reduxjs/toolkit";
import {
  getBlog,
  blogcategory,
  patchApiData,
  getblogpatch,
  advanceSearchget,
  getAllBlogCategory,
} from "./actionCreater";
import initialState from "./state";

export const blogSlice = createSlice({
  name: "blog",
  initialState,
  reducers: {
    setPaginationModel(state, action) {
      state.page = action.payload.page;
      state.limit = action.payload.pageSize;
    },
    resetPaginationModel(state, action) {
      state.page = 0;
      state.limit = 25;
    },
    setSearchKey(state, action) {
      state.searchKey = action.payload;
    },
    setResetAdvanceSearch(state, action) {},
    searchKeyChanged(state, action) {
      state.searchKey = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getBlog.pending, (state) => {});
    builder.addCase(getBlog.fulfilled, (state, action) => {
      state.blogData.bloginfo = action?.payload?.data?.payload;
      console.log(action?.payload?.data?.payload, "hhhhh");
      state.total = action?.payload?.data?.payload?.totalCount;
    });
    builder.addCase(getBlog.rejected, (state, action) => {});

    builder.addCase(advanceSearchget.pending, (state) => {});
    builder.addCase(advanceSearchget.fulfilled, (state, action) => {
      state.blogData.bloginfo = action?.payload?.payload;
      console.log(action?.payload?.payload, "hh>>>>");
    });
    builder.addCase(advanceSearchget.rejected, (state, action) => {});

    builder.addCase(blogcategory.pending, (state) => {});
    builder.addCase(blogcategory.fulfilled, (state, action) => {
      // console.log(action?.payload?.data.payload,"///")
      state.blogcatedata = action?.payload?.data?.payload;
    });
    builder.addCase(blogcategory.rejected, (state, action) => {});

    builder.addCase(patchApiData.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(patchApiData.fulfilled, (state, action) => {
      state.loading = false;
      state.data = action.payload;
    });
    builder.addCase(patchApiData.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message;
    });

    builder.addCase(getAllBlogCategory.pending, (state) => {});
    builder.addCase(getAllBlogCategory.fulfilled, (state, action) => {
      state.blogCategoryInfo = action?.payload?.data?.payload;
      console.log(action?.payload?.data?.payload, "getBlogCategory");
    });
    builder.addCase(getAllBlogCategory.rejected, (state, action) => {});
  },
});

export const {
  setPaginationModel,
  resetPaginationModel,
  setSearchKey,
  searchKeyChanged,
} = blogSlice.actions;

export default blogSlice.reducer;
